const messages = {
  title: "Productbrochures",
  list: "",
  description:
    "Download hier de nieuwste brochures en salestools over onze Bridgestone en Firestone banden.",
  brochureCategories: {
    products: "Producten",
    brand_and_solutions: "Merk",
    season_and_promotions: "Seizoen & Promoties",
    format: "Formaat",
    cars_and_vans: "Car/bestelwagens",
    promotions: "Promoties",
    all_season: "All season",
    truck_and_buses: "Vrachtwagens en bussen",
    motorcycle: "Motor",
    agriculture: "Landbouw",
    construction_machinery: "Grondverzet",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Brochures",
    price_list: "Prijslijst",
    materials: "Materialen",
    video_in_store: "Video met ondertiteling",
    video_online: "Video zonder ondertiteling",
    banner_website: "Banner",
    banner_social_media: "Sociale Media",
    logos: "Logo’s",
    technology: "Technology",
    oe: "OE",
    summer: "Zomer",
    allSeason: "All season",
    winter: "Winter",
    trucks: "Truck",
    season: "Seizoen",
  },
  searchMedia: "Zoekterm invoeren",
  searchResults: "Zoekresultaten",
};

export default {
  messages,
};
